// Utility functions for the application

/**
 * Get the correct base URL based on the environment
 */
export const getBaseUrl = (path: string = ''): string => {
  // Special case for API endpoints that use Supabase Functions
  if (path === '/api/generate-print-files') {
    return `https://oxhnadkffqsygzxtidfe.supabase.co/functions/v1/generate-print-files`;
  }

  // For all paths (including API routes), use the current origin
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return `${window.location.origin}${path}`;
    }
    // In production, use qrcodefeedback.com
    return `https://www.qrcodefeedback.com${path}`;
  }
  
  // Server-side fallback
  return `https://www.qrcodefeedback.com${path}`;
};

/**
 * Get the redirect URL for authentication flows
 */
export const getAuthRedirectUrl = (path: string = ''): string => {
  return getBaseUrl(path);
}; 